"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconPropositionEngineImpl = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var FalconPropositionEngineImpl = exports.FalconPropositionEngineImpl = /** @class */ (function (_super) {
    __extends(FalconPropositionEngineImpl, _super);
    function FalconPropositionEngineImpl(configuration, notificationService) {
        var _this = _super.call(this) || this;
        _this.configuration = configuration;
        _this.authMandatory = false;
        if (_this.configuration.authMandatory !== undefined) {
            _this.authMandatory = _this.configuration.authMandatory;
        }
        _this.notificationService = notificationService;
        return _this;
    }
    FalconPropositionEngineImpl.prototype.fetchInteractionByEmailAndDob = function (product, id, email, dateOfBirth) {
        var url = "".concat(this.configuration.serviceBaseUrl, "/products/").concat(product, "/interaction/").concat(id, "?email=").concat(email, "&dob=").concat(dateOfBirth);
        return _super.prototype.getProtectedResource.call(this, {
            url: url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            console.error("Caught 'FalconPropositionEngineImpl' service API response error", err);
            return (0, rxjs_1.of)(null);
        }));
    };
    FalconPropositionEngineImpl.prototype.fetchJourneyByInteractionEmailAndDob = function (product, process, id, languageCode, email, dateOfBirth) {
        var url = "".concat(this.configuration.serviceBaseUrl, "/products/").concat(product, "/process/").concat(process, "/interaction/").concat(id, "/language/").concat(languageCode, "?email=").concat(email, "&dob=").concat(dateOfBirth);
        return _super.prototype.getProtectedResource.call(this, {
            url: url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            console.error("Caught 'FalconPropositionEngineImpl' service API response error", err);
            return (0, rxjs_1.of)(null);
        }));
    };
    FalconPropositionEngineImpl.prototype.fetchSessionInformation = function () {
        var _this = this;
        var url = "".concat(this.configuration.serviceBaseUrl, "/session");
        return _super.prototype.getProtectedResource.call(this, {
            url: url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)(function (response) {
            return response.response;
        }), (0, operators_1.catchError)(function (err) {
            _this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.of)({});
        }));
    };
    FalconPropositionEngineImpl.prototype.fetchInteractionByToken = function (token) {
        var url = "".concat(this.configuration.serviceBaseUrl, "/startJourney/").concat(token);
        return _super.prototype.getProtectedResource.call(this, {
            url: url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory);
    };
    FalconPropositionEngineImpl = __decorate([
        (0, core_1.injectable)(),
        __param(0, (0, core_1.inject)(Types_1.Types.RuntimeServiceConfig)),
        __param(1, (0, core_1.inject)(Types_1.Types.NotificationService)),
        __metadata("design:paramtypes", [Object, Object])
    ], FalconPropositionEngineImpl);
    return FalconPropositionEngineImpl;
}(core_1.RestService));
//# sourceMappingURL=FalconPropositionEngineImpl.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/services/impl/FalconPropositionEngineImpl.js
// module id = 2524
// module chunks = 0